import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from '../../shared/shared.module';
import { ProfileSettingsService } from '../profile-settings/services/profile-settings.service';
import { ContainerSearchDropdownComponent } from './components/container-search-dropdown/container-search-dropdown.component';
import { FocAccountsModalComponent } from './components/foc-accounts-modal/foc-accounts-modal.component';
import { ReturnLabelModalComponent } from './components/return-label-modal/return-label-modal.component';
import { ShipmentsComponent } from './components/shipments/shipments.component';
import { UserViewsModule } from '../../shared/sub-modules/user-views/user-views.module';

@NgModule({
  declarations: [
    ContainerSearchDropdownComponent,
    ShipmentsComponent,
    ReturnLabelModalComponent,
    FocAccountsModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    SharedModule,
    UserViewsModule
  ],
  exports: [ShipmentsComponent],
  providers: [ProfileSettingsService],
})
export class ShipmentsModule {}
